import type { DbEnv } from "common/constants/db";

// TODO Break the dependency on the DB env - stop using the DB Env as a backstop for the S3 Env
export type S3Env = DbEnv | "test" | "image-catalog" | "higharc-props" | "selections";

export function isS3TestEnv(env: S3Env): boolean {
  return env === "test";
}

export interface PublicBucketConfig {
  bucketName: string;
  region: string;
}

export const publicBucketsByEnv: Record<S3Env, PublicBucketConfig> = {
  develop_local_dump: {
    bucketName: "product-develop",
    region: "us-east-1",
  },
  stage_local_dump: {
    bucketName: "product-develop",
    region: "us-east-1",
  },
  prod_local_dump: {
    bucketName: "product-develop",
    region: "us-east-1",
  },
  prod: {
    bucketName: "aekveym7hu-product-prod",
    region: "us-east-1",
  },
  stage: {
    bucketName: "product-stage",
    region: "us-east-1",
  },
  qa: {
    bucketName: "product-qa-higharc",
    region: "us-east-1",
  },
  develop: {
    bucketName: "product-develop",
    region: "us-east-1",
  },
  sandbox1: {
    bucketName: "product-sandbox1",
    region: "us-east-1",
  },
  sandbox2: {
    bucketName: "product-sandbox2",
    region: "us-east-1",
  },
  sandbox3: {
    bucketName: "product-sandbox3",
    region: "us-east-1",
  },
  sandbox4: {
    bucketName: "product-sandbox4",
    region: "us-east-1",
  },
  sandbox5: {
    bucketName: "product-sandbox5",
    region: "us-east-1",
  },
  sandbox6: {
    bucketName: "product-sandbox6",
    region: "us-east-1",
  },
  sandbox7: {
    bucketName: "product-sandbox7",
    region: "us-east-1",
  },
  sandbox8: {
    bucketName: "product-sandbox8",
    region: "us-east-1",
  },
  sandbox9: {
    bucketName: "product-sandbox9",
    region: "us-east-1",
  },
  sandbox10: {
    bucketName: "product-sandbox10",
    region: "us-east-1",
  },
  sandbox11: {
    bucketName: "product-sandbox11",
    region: "us-east-1",
  },
  sandbox12: {
    bucketName: "product-sandbox12",
    region: "us-east-1",
  },
  sandbox13: {
    bucketName: "product-sandbox13",
    region: "us-east-1",
  },
  sandbox14: {
    bucketName: "product-sandbox14",
    region: "us-east-1",
  },
  sandbox15: {
    bucketName: "product-sandbox15",
    region: "us-east-1",
  },
  sandbox16: {
    bucketName: "product-sandbox16",
    region: "us-east-1",
  },
  sandbox17: {
    bucketName: "product-sandbox17",
    region: "us-east-1",
  },
  sandbox18: {
    bucketName: "product-sandbox18",
    region: "us-east-1",
  },
  sandbox19: {
    bucketName: "product-sandbox19",
    region: "us-east-1",
  },
  sandbox20: {
    bucketName: "product-sandbox20",
    region: "us-east-1",
  },
  demo1: {
    bucketName: "product-demo1",
    region: "us-east-1",
  },
  demo2: {
    bucketName: "product-demo2-higharc",
    region: "us-east-1",
  },
  pr: {
    bucketName: "product-pr",
    region: "us-east-1",
  },
  local: {
    bucketName: "product-develop",
    region: "us-east-1",
  },
  test: {
    bucketName: "higharc-product-test",
    region: "us-east-1",
  },
  local_test: {
    bucketName: "higharc-product-test",
    region: "us-east-1",
  },
  docker_test: {
    bucketName: "higharc-product-test",
    region: "us-east-1",
  },
  ["image-catalog"]: {
    bucketName: "higharc-image-catalog",
    region: "us-east-2",
  },
  ["higharc-props"]: {
    bucketName: "higharc-props",
    region: "us-east-1",
  },
  selections: {
    bucketName: "photoreal-test",
    region: "us-east-1",
  },
};

export function s3BucketUrl(bucketName: string, region: string, key?: string): string {
  return `https://${bucketName}.s3.${region}.amazonaws.com/${key ?? ""}`;
}

export function publicBucketUrlForEnv(env: S3Env, key?: string): string {
  const { bucketName, region } = publicBucketsByEnv[env];
  return s3BucketUrl(bucketName, region, key);
}

export function s3EnvFromEnvVars(): S3Env | undefined {
  const rawEnv = process.env.S3_ENV || process.env.DB_ENV;
  if (!rawEnv) {
    return undefined;
  }

  if (rawEnv in publicBucketsByEnv) {
    return rawEnv as S3Env;
  }

  return undefined;
}
